import React from "react";
import Boxes from "./Boxes.js";
import WideImg from "../images/leaderboard_img.png";
import Grid from "../components/Grid";

export default function Main() {
  return (
    <>
      <div className="introMain">
        <h1 className="intro"> GET REWARDED IN THREE EASY STEPS </h1>
      </div>

      <Boxes />

      <div className="container center">
        <p className="textBox1">
        There's more dough to go around with our NEW rewards program &mdash; Ed's Dough. As a member, you'll collect two points for every dollar spent! In just a few purchases, those points can add up to some pretty tasty rewards. To sign up, just order online from your nearest Me-N-Ed's location, login, and you'll have the option to sign up! 
        </p>
      </div>

      <div className="fullImage">
        <img src={WideImg} alt="leaderboard" />
      </div>

      <div className="introMain2">
        <h1 className="intro"> REWARDS MENU </h1>
      </div>

      <Grid />
    </>
  );
}
